import { useLocale } from '@plugins/bw-i18next'
import { graphql, useStaticQuery } from 'gatsby'

let tNodes
export const useTranslation = () => {
  const { currentContentfulCode } = useLocale()

  if (!tNodes) {
    tNodes = useStaticQuery(graphql`
      query AllContentfulTranslations {
        allContentfulTranslations {
          nodes {
            node_locale
            key
            phrase
          }
        }
      }
    `).allContentfulTranslations.nodes
  }

  const t = (key) => {
    const node = tNodes.find((node) => node.key === key && node.node_locale === currentContentfulCode)
    return node?.phrase || key
  }

  return { t }
}
